<div class="content-area">
  <div class="row pt-3">
    <div
      _ngcontent-ng-c304434697=""
      class="back-btn-container pointer"
      style="margin-top: 2rem"
    >
      &nbsp;
    </div>
    <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 mx-auto">
      <div class="card shadow text-start p-5 p-2-mobile">
        <div class="card-body p-2">
          <img
            src="assets/images/tick-icon.png"
            alt="Verifycation Complete"
            class="img-fluid mb-4 d-block mx-auto w-80"
          />
          <h4 class="text-center">Verification Complete</h4>
          <div class="d-flex justify-content-center">
            <p class="card-text m-3 mb-4 text-center text-muted">
              Your account has been successfully created. Please login to set up
              your account.
            </p>
          </div>
          <button
            type="submit"
            (click)="login()"
            class="btn btn-secondary w-100 mb-4"
          >
            Return to Login
          </button>
          <p class="text-center text-muted help-div">
            Need help?
            <a href="mailto:eu.enterprisesupport@firstorion.com" class="text-primary text-decoration-none">
              Contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
